import { render, staticRenderFns } from "./ClientDashboard.vue?vue&type=template&id=c464e8e2&scoped=true&"
import script from "./ClientDashboard.vue?vue&type=script&lang=js&"
export * from "./ClientDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ClientDashboard.vue?vue&type=style&index=0&id=c464e8e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c464e8e2",
  null
  
)

export default component.exports